/* eslint-disable quotes */
export const AbrExampleByName = {
    "ABRSearchByNameAdvancedSimpleProtocol2017Response": {
        "result": "ABRSearchByNameAdvancedSimpleProtocol2017Result",
        "ABRSearchByNameAdvancedSimpleProtocol2017Result": {
            "@id": "id1",
            "Request": {
                "@id": "id2",
                "ExternalRequestBody": {
                    "@id": "id3",
                    "AuthenticationGUID": "e9959e02-eccd-40c6-be26-7d1a19267b95",
                    "Name": "Service NSW",
                    "Filters": {
                        "@id": "id4",
                        "NameType": {
                            "@id": "id5",
                            "TradingName": "Y",
                            "LegalName": "Y",
                            "BusinessName": "Y"
                        },
                        "Postcode": "",
                        "StateCode": {
                            "@id": "id6",
                            "QLD": "Y",
                            "NT": "Y",
                            "SA": "Y",
                            "WA": "Y",
                            "VIC": "Y",
                            "ACT": "Y",
                            "TAS": "Y",
                            "NSW": "Y"
                        },
                        "ActiveABNsOnly": "Y"
                    },
                    "SearchWidth": "Typical",
                    "MinimumScore": 0,
                    "MaxSearchResults": 10
                }
            },
            "Response": {
                "@id": "id7",
                "UsageStatement": "The Registrar of the ABR monitors the quality of the information available on this website and updates the information regularly. However, neither the Registrar of the ABR nor the Commonwealth guarantee that the information available through this service (including search results) is accurate, up to date, complete or accept any liability arising from the use of or reliance upon this site.",
                "DateRegisterLastUpdated": "2023-09-06T00:00:00",
                "DateTimeRetrieved": "2023-09-06T16:16:14.8974437+10:00",
                "ResponseBody": {
                    "@id": "id8",
                    "NumberOfRecords": 10,
                    "ExceedsMaximum": "N",
                    "SearchResultsRecord": {
                        "@id": "id9",
                        "@itemType": "types:SearchResultsRecord",
                        "@arraySize": 10,
                        "Item": [
                            {
                                "@id": "id10",
                                "NameType": {
                                    "@id": "id11",
                                    "@itemType": "types:NameType",
                                    "@arraySize": 1,
                                    "Item": "mainName"
                                },
                                "ABN": {
                                    "@id": "id12",
                                    "@itemType": "types:IdentifierSummary",
                                    "@arraySize": 1,
                                    "Item": {
                                        "@id": "id13",
                                        "IdentifierValue": 37552837401,
                                        "IdentifierStatus": "Active"
                                    }
                                },
                                "Name": {
                                    "@id": "id14",
                                    "@itemType": "xsd:anyType",
                                    "@arraySize": 1,
                                    "Item": {
                                        "@id": "id15",
                                        "OrganisationName": "SERVICE NSW",
                                        "Score": 100,
                                        "IsCurrentIndicator": "Y"
                                    }
                                },
                                "MainBusinessPhysicalAddress": {
                                    "@id": "id16",
                                    "@itemType": "types:AddressSimple",
                                    "@arraySize": 1,
                                    "Item": {
                                        "@id": "id17",
                                        "StateCode": "NSW",
                                        "Postcode": 2000,
                                        "IsCurrentIndicator": "Y"
                                    }
                                }
                            },
                            {
                                "@id": "id18",
                                "NameType": {
                                    "@id": "id19",
                                    "@itemType": "types:NameType",
                                    "@arraySize": 1,
                                    "Item": "businessName"
                                },
                                "ABN": {
                                    "@id": "id20",
                                    "@itemType": "types:IdentifierSummary",
                                    "@arraySize": 1,
                                    "Item": {
                                        "@id": "id21",
                                        "IdentifierValue": 57164351446,
                                        "IdentifierStatus": "Active"
                                    }
                                },
                                "Name": {
                                    "@id": "id22",
                                    "@itemType": "xsd:anyType",
                                    "@arraySize": 1,
                                    "Item": {
                                        "@id": "id23",
                                        "OrganisationName": "Service NSW",
                                        "Score": 100,
                                        "IsCurrentIndicator": "Y"
                                    }
                                },
                                "MainBusinessPhysicalAddress": {
                                    "@id": "id24",
                                    "@itemType": "types:AddressSimple",
                                    "@arraySize": 1,
                                    "Item": {
                                        "@id": "id25",
                                        "StateCode": "NSW",
                                        "Postcode": 2287,
                                        "IsCurrentIndicator": "Y"
                                    }
                                }
                            },
                            {
                                "@id": "id26",
                                "NameType": {
                                    "@id": "id27",
                                    "@itemType": "types:NameType",
                                    "@arraySize": 1,
                                    "Item": "mainName"
                                },
                                "ABN": {
                                    "@id": "id28",
                                    "@itemType": "types:IdentifierSummary",
                                    "@arraySize": 1,
                                    "Item": {
                                        "@id": "id29",
                                        "IdentifierValue": 66658389667,
                                        "IdentifierStatus": "Active"
                                    }
                                },
                                "Name": {
                                    "@id": "id30",
                                    "@itemType": "xsd:anyType",
                                    "@arraySize": 1,
                                    "Item": {
                                        "@id": "id31",
                                        "OrganisationName": "A2Z SERVICES NSW PTY LTD",
                                        "Score": 97,
                                        "IsCurrentIndicator": "Y"
                                    }
                                },
                                "MainBusinessPhysicalAddress": {
                                    "@id": "id32",
                                    "@itemType": "types:AddressSimple",
                                    "@arraySize": 1,
                                    "Item": {
                                        "@id": "id33",
                                        "StateCode": "NSW",
                                        "Postcode": 2165,
                                        "IsCurrentIndicator": "Y"
                                    }
                                }
                            },
                            {
                                "@id": "id34",
                                "NameType": {
                                    "@id": "id35",
                                    "@itemType": "types:NameType",
                                    "@arraySize": 1,
                                    "Item": "mainName"
                                },
                                "ABN": {
                                    "@id": "id36",
                                    "@itemType": "types:IdentifierSummary",
                                    "@arraySize": 1,
                                    "Item": {
                                        "@id": "id37",
                                        "IdentifierValue": 33654452838,
                                        "IdentifierStatus": "Active"
                                    }
                                },
                                "Name": {
                                    "@id": "id38",
                                    "@itemType": "xsd:anyType",
                                    "@arraySize": 1,
                                    "Item": {
                                        "@id": "id39",
                                        "OrganisationName": "ABH SERVICES (NSW) PTY LTD",
                                        "Score": 97,
                                        "IsCurrentIndicator": "Y"
                                    }
                                },
                                "MainBusinessPhysicalAddress": {
                                    "@id": "id40",
                                    "@itemType": "types:AddressSimple",
                                    "@arraySize": 1,
                                    "Item": {
                                        "@id": "id41",
                                        "StateCode": "NSW",
                                        "Postcode": 2526,
                                        "IsCurrentIndicator": "Y"
                                    }
                                }
                            },
                            {
                                "@id": "id42",
                                "NameType": {
                                    "@id": "id43",
                                    "@itemType": "types:NameType",
                                    "@arraySize": 1,
                                    "Item": "mainName"
                                },
                                "ABN": {
                                    "@id": "id44",
                                    "@itemType": "types:IdentifierSummary",
                                    "@arraySize": 1,
                                    "Item": {
                                        "@id": "id45",
                                        "IdentifierValue": 20073584700,
                                        "IdentifierStatus": "Active"
                                    }
                                },
                                "Name": {
                                    "@id": "id46",
                                    "@itemType": "xsd:anyType",
                                    "@arraySize": 1,
                                    "Item": {
                                        "@id": "id47",
                                        "OrganisationName": "ABSOLUTE SERVICES (NSW) PTY LTD",
                                        "Score": 97,
                                        "IsCurrentIndicator": "Y"
                                    }
                                },
                                "MainBusinessPhysicalAddress": {
                                    "@id": "id48",
                                    "@itemType": "types:AddressSimple",
                                    "@arraySize": 1,
                                    "Item": {
                                        "@id": "id49",
                                        "StateCode": "NSW",
                                        "Postcode": 2075,
                                        "IsCurrentIndicator": "Y"
                                    }
                                }
                            },
                            {
                                "@id": "id50",
                                "NameType": {
                                    "@id": "id51",
                                    "@itemType": "types:NameType",
                                    "@arraySize": 1,
                                    "Item": "mainName"
                                },
                                "ABN": {
                                    "@id": "id52",
                                    "@itemType": "types:IdentifierSummary",
                                    "@arraySize": 1,
                                    "Item": {
                                        "@id": "id53",
                                        "IdentifierValue": 11125378921,
                                        "IdentifierStatus": "Active"
                                    }
                                },
                                "Name": {
                                    "@id": "id54",
                                    "@itemType": "xsd:anyType",
                                    "@arraySize": 1,
                                    "Item": {
                                        "@id": "id55",
                                        "OrganisationName": "ACCOUNTING SERVICES (NSW) PTY LTD",
                                        "Score": 97,
                                        "IsCurrentIndicator": "Y"
                                    }
                                },
                                "MainBusinessPhysicalAddress": {
                                    "@id": "id56",
                                    "@itemType": "types:AddressSimple",
                                    "@arraySize": 1,
                                    "Item": {
                                        "@id": "id57",
                                        "StateCode": "NSW",
                                        "Postcode": 2065,
                                        "IsCurrentIndicator": "Y"
                                    }
                                }
                            },
                            {
                                "@id": "id58",
                                "NameType": {
                                    "@id": "id59",
                                    "@itemType": "types:NameType",
                                    "@arraySize": 1,
                                    "Item": "mainTradingName"
                                },
                                "ABN": {
                                    "@id": "id60",
                                    "@itemType": "types:IdentifierSummary",
                                    "@arraySize": 1,
                                    "Item": {
                                        "@id": "id61",
                                        "IdentifierValue": 59744112886,
                                        "IdentifierStatus": "Active"
                                    }
                                },
                                "Name": {
                                    "@id": "id62",
                                    "@itemType": "xsd:anyType",
                                    "@arraySize": 1,
                                    "Item": {
                                        "@id": "id63",
                                        "OrganisationName": "ADA SERVICES (NSW) PTY LTD ATF THE ARAPIDIS FAMILY TRUST",
                                        "Score": 97,
                                        "IsCurrentIndicator": "Y"
                                    }
                                },
                                "MainBusinessPhysicalAddress": {
                                    "@id": "id64",
                                    "@itemType": "types:AddressSimple",
                                    "@arraySize": 1,
                                    "Item": {
                                        "@id": "id65",
                                        "StateCode": "NSW",
                                        "Postcode": 2114,
                                        "IsCurrentIndicator": "Y"
                                    }
                                }
                            },
                            {
                                "@id": "id66",
                                "NameType": {
                                    "@id": "id67",
                                    "@itemType": "types:NameType",
                                    "@arraySize": 1,
                                    "Item": "mainName"
                                },
                                "ABN": {
                                    "@id": "id68",
                                    "@itemType": "types:IdentifierSummary",
                                    "@arraySize": 1,
                                    "Item": {
                                        "@id": "id69",
                                        "IdentifierValue": 57634198011,
                                        "IdentifierStatus": "Active"
                                    }
                                },
                                "Name": {
                                    "@id": "id70",
                                    "@itemType": "xsd:anyType",
                                    "@arraySize": 1,
                                    "Item": {
                                        "@id": "id71",
                                        "OrganisationName": "ADAPTIVE SERVICES (NSW) PTY LTD",
                                        "Score": 97,
                                        "IsCurrentIndicator": "Y"
                                    }
                                },
                                "MainBusinessPhysicalAddress": {
                                    "@id": "id72",
                                    "@itemType": "types:AddressSimple",
                                    "@arraySize": 1,
                                    "Item": {
                                        "@id": "id73",
                                        "StateCode": "NSW",
                                        "Postcode": 2111,
                                        "IsCurrentIndicator": "Y"
                                    }
                                }
                            },
                            {
                                "@id": "id74",
                                "NameType": {
                                    "@id": "id75",
                                    "@itemType": "types:NameType",
                                    "@arraySize": 1,
                                    "Item": "mainName"
                                },
                                "ABN": {
                                    "@id": "id76",
                                    "@itemType": "types:IdentifierSummary",
                                    "@arraySize": 1,
                                    "Item": {
                                        "@id": "id77",
                                        "IdentifierValue": 68634865133,
                                        "IdentifierStatus": "Active"
                                    }
                                },
                                "Name": {
                                    "@id": "id78",
                                    "@itemType": "xsd:anyType",
                                    "@arraySize": 1,
                                    "Item": {
                                        "@id": "id79",
                                        "OrganisationName": "ADVANCED SERVICES (NSW) PTY LTD",
                                        "Score": 97,
                                        "IsCurrentIndicator": "Y"
                                    }
                                },
                                "MainBusinessPhysicalAddress": {
                                    "@id": "id80",
                                    "@itemType": "types:AddressSimple",
                                    "@arraySize": 1,
                                    "Item": {
                                        "@id": "id81",
                                        "StateCode": "NSW",
                                        "Postcode": 2163,
                                        "IsCurrentIndicator": "Y"
                                    }
                                }
                            },
                            {
                                "@id": "id82",
                                "NameType": {
                                    "@id": "id83",
                                    "@itemType": "types:NameType",
                                    "@arraySize": 1,
                                    "Item": "businessName"
                                },
                                "ABN": {
                                    "@id": "id84",
                                    "@itemType": "types:IdentifierSummary",
                                    "@arraySize": 1,
                                    "Item": {
                                        "@id": "id85",
                                        "IdentifierValue": 67534108553,
                                        "IdentifierStatus": "Active"
                                    }
                                },
                                "Name": {
                                    "@id": "id86",
                                    "@itemType": "xsd:anyType",
                                    "@arraySize": 1,
                                    "Item": {
                                        "@id": "id87",
                                        "OrganisationName": "AFFORDABLE SERVICES NSW",
                                        "Score": 97,
                                        "IsCurrentIndicator": "Y"
                                    }
                                },
                                "MainBusinessPhysicalAddress": {
                                    "@id": "id88",
                                    "@itemType": "types:AddressSimple",
                                    "@arraySize": 1,
                                    "Item": {
                                        "@id": "id89",
                                        "StateCode": "NSW",
                                        "Postcode": 2168,
                                        "IsCurrentIndicator": "Y"
                                    }
                                }
                            }
                        ]
                    }
                }
            }
        }
    }
};